import { render } from "./PitchDeck.vue?vue&type=template&id=09a0f704"
import script from "./PitchDeck.vue?vue&type=script&lang=js"
export * from "./PitchDeck.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__